import EditorTitle from './EditorTitle'
export { default as EditorTitleCompact } from './EditorTitleCompact'
export default EditorTitle
